<br>

<div style="width: auto; overflow: auto">
    <app-common-list-table
            [request]="getRequest"
            [filtering]="filtering"
            [cols]="cols"
            [globalConditionalStyle]="globalConditionalStyle"
            [globalVisualTransform]="globalVisualTransform"
            actionButtonText="Añadir Plantación"
            (emitSearchText)="updateFooter()"
            (actionButtonClick)="add()">
            <ng-template #header>
                <div class="d-flex gap-4 flex-row align-self-end m-0 text-black">
                    <div class="d-flex flex-column justify-content-center align-content-center p-0 m-0">
                        <label>Realizados</label>
                        <p-selectbutton [options]="optionsSelectButton" optionLabel="label" optionValue="value" (onChange)="filtrar()"
                            [formControl]="realizadoControl" aria-labelledby="basic">
                        </p-selectbutton>
                    </div>
                    <div class="d-flex flex-column justify-content-center align-content-center p-0 m-0">
                        <label class="bagde" for="f_Init">F.Inicio</label>
                        <app-datepicker id="f_Init" (sendFecha)="getFechaInicio($event)" />
                    </div>
                    <div class="d-flex flex-column justify-content-center align-content-center p-0 m-0" style="margin-left: 20px;">
                        <label class="bagde" for="f_Fin">F.Fin</label>
                        <app-datepicker id="f_Fin" (sendFecha)="getFechaFin($event)" />
                    </div>
                    <button class="align-self-center mx-2 btn" (click)="downloadCsv()"
                        style="font-size: .8rem; background-color: #16A2B7; color: white">
                        <i class="fa fa-download"></i>
                        Exportar listado
                    </button>
                </div>
            </ng-template>
        <ng-template #thEnd>
            <th>
                <p class="d-flex justify-content-center"
                   style="margin-bottom: 0">Acciones</p>
            </th>
        </ng-template>

    <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
      <td>
          <app-action-buttons
                [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                        [hideDelete]="hiddenButtonDelete" [showDuplicate]="true"
                        (duplicateRowButtonEvent)="duplicate(data.data)"
                        (editRowButtonEvent)="edit(data.data)"
                        (deleteRowButtonEvent)="show('delete', data.data)"
                        (showRowButtonEvent)="show('info', data.data)">
                </app-action-buttons>
            </td>

        </ng-template>

        <ng-template #footer let-col>
            <div style="font-size: 0.75em; text-align: left" *ngIf="(['cliente_nombre'].includes(col.field))">
              TOTAL:
            </div>
            <div *ngIf="(['horas'].includes(col.field))"
              style="font-size: 0.75em; text-align: right; font-weight: bold; padding-right: 34px">
              {{this.totalHoras  || 0}}
            </div>
        </ng-template>

    </app-common-list-table>
</div>

<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="env.serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>
